import React, { Component } from 'react';

import {} from './App.css';
import Header from './components/Header.js';
import Sidebar from './components/Sidebar.js';
import Footer from './components/Footer.js';

class App extends Component {
  render() {
    return (
      <div className="App">
       <Header/>
        <div className="App-page">
          <div className="App-mainpage"> 
            {this.props.children}
          </div>
          <div className="App-sidepanel">
            <Sidebar />
          </div>
        </div>
        <div className="App-footer">
          <Footer />
        </div>
      </div>
    );
  }
}

export default App;


// WEBPACK FOOTER //
// ./src/App.js